import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BeamerService } from './beamer.service';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { AppLayoutStateService } from '../app-layout.state-service';
import { CssBreakpointsService } from '@design/layout/css-breakpoints.service';
import { ActiveCintraProductService } from '@app/active-cintra-product.service';
import { CintraProduct, getProductHelpUrl } from '@app/cintra-product';
import { map } from 'rxjs/operators';
import { FeatureFlagService, FeatureFlagsServiceInjectionToken } from '@feature-flags/feature-flag.service';

/**
 * Static app header. Static in that it's a permanent layout fixture, but its content is dynamic:
 * 1. Access to the {@link BurgerBarComponent}
 * 2. User my-profile "My Account" menu populated on sign-in
 * 3. Product navbar to navigate between products (Payrolls, Bureau, Employee Hub etc.)
 * Shares models via {@link AppLayoutStateService}. Embedded in {@link AppLayoutComponent}
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BeamerService],
  standalone: false
})
export class HeaderComponent implements OnInit {
  activeAreas$ = this.activeSecurity.activeAreas$;

  elementIdForBeamer = BeamerService.elementIdForBeamer;

  fullName$ = this.activeSecurity.activeUser$.pipe(map((info) => `${info.forename} ${info.surname}`));
  isImpersonated = () => this.activeSecurity.isImpersonated();
  endUserImpersonation = () => this.activeSecurity.endUserImpersonation();
  getProductHelpUrl = getProductHelpUrl;

  constructor(
    public activeSecurity: ActiveSecurityContextStateService,
    public beamerService: BeamerService,
    private router: Router,
    public activeCintraProductService: ActiveCintraProductService,
    public cssBreakpointsService: CssBreakpointsService,
    public appLayout: AppLayoutStateService,
    @Inject(FeatureFlagsServiceInjectionToken) private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {
    this.beamerService.initialise();
  }

  navigateProduct = (cintraProduct: CintraProduct) => {
    ActiveCintraProductService.cachedActiveProduct = cintraProduct;

    this.activeAreas$.subscribe((userNav) => {
      if (cintraProduct === 'EmployeeHub') {
        this.router.navigateByUrl(userNav.employeeHubTab.path).then();
      } else if (cintraProduct == 'AdminHub') {
        this.router.navigateByUrl(userNav.adminHubTab.path).then();
      } else if (cintraProduct === 'Bureau') {
        this.router.navigateByUrl(userNav.bureauTab.path).then();
      } else if (cintraProduct === 'HR') {
        document.location.href = userNav.hrTab.path;
      } else {
        this.router.navigateByUrl(userNav.payrollTab.path).then();
      }
    });
  };

  home = () => this.activeSecurity.navigateHome();
}
